<!-- 排出事業者form -->
<template>
  <div>
    <v-row>
      <v-col>
        <v-tabs
          v-model="emissionForm"
          background-color="blue lighten-4"
          centered
          icons-and-text
          fixed-tabs
        >
          <v-tabs-slider />

          <v-tab href="#tab-basic">
            排出事業者
            <v-icon>mdi-bank</v-icon>
          </v-tab>

          <v-tab
            :disabled="!masterEmission"
            href="#tab-locations"
          >
            事業場
            <v-icon>mdi-factory</v-icon>
          </v-tab>

          <v-tab v-if="false" href="#tab-items">
            取扱品目
            <v-icon>mdi-layers</v-icon>
          </v-tab>

          <v-tab
            :disabled="!masterEmission"
            href="#tab-persons"
          >
            担当者
            <v-icon>mdi-account</v-icon>
          </v-tab>
          <v-tab
            :disabled="!masterEmission"
            href="#tab-entry_patterns"
          >
            登録パターン
            <v-icon>mdi-text-box-multiple-outline</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="emissionForm">
          <v-tab-item value="tab-basic">
            <basic-form :is-edit="true" @callbackToParent="callbackToParent" />
          </v-tab-item>

          <v-tab-item value="tab-locations">
            <location-form :master-emission="masterEmission" />
          </v-tab-item>

          <v-tab-item value="tab-items">
            <item-form />
          </v-tab-item>

          <v-tab-item value="tab-persons">
            <user-form />
          </v-tab-item>

          <v-tab-item value="tab-entry_patterns">
            <emission-entry-pattern ref="entryPatternComponent" :emission="masterEmission" />
          </v-tab-item>

        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import BasicForm from "./forms/_Basic"
  import LocationForm from "./forms/_Location"
  import ItemForm from "./forms/_Item"
  import UserForm from "./forms/_User"
  import EmissionEntryPattern from "./forms/_EntryPattern.vue";
  export default {
    name: 'MasterEmissionForm',
    components: {
      EmissionEntryPattern,
      BasicForm,
      LocationForm,
      ItemForm,
      UserForm,
    },
    mixins: [],
    props: {
      masterEmission: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        emissionForm: 'basicTab',
      }
    },
    computed: {},
    watch: {
      emissionForm(newTab) {
        // 登録パターンタブに切り替わった時に再読み込み
        if (newTab === 'tab-entry_patterns' && this.$refs.entryPatternComponent) {
          this.$refs.entryPatternComponent.searchEmissionEntryPatterns();
        }
      }
    },
    methods: {
      callbackToParent () {
        this.$emit('editCallback')
      }
    },
  }
</script>

<style lang="scss">
  .v-window-item > .v-card
  {
    min-height:300px;
  }
</style>
